import { FormattedMessage, useIntl } from 'react-intl';
import { ReactNode } from 'react';

import { Button } from '../../../common/button-new';
import { AppointmentRequestButtonProps, RequestButtonProps } from './appointment-request-button.models';
import { Preloader } from '../../../common/preloader';
import { getServiceButton } from './utils/get-button-label';
import { useStyles } from './appointment-request-button.styles';
import { InternalLinks } from '../../../../constants';
import { getServiceLabelId } from '../../../../utils';

const RequestButton = ({ disabled, appointmentUrl, onClick, ecpService, testId }: RequestButtonProps) => {
  const buttonSettings = getServiceButton(ecpService);

  return (
    <Button
      testId={testId ?? 'appointment-request-button'} // Used by YM
      style={buttonSettings.style}
      to={appointmentUrl}
      target="_blank"
      onClick={onClick}
      disabled={disabled}
    >
      <FormattedMessage id={buttonSettings.label} values={{ noBreak: <>&nbsp;</> }} />
    </Button>
  );
};

export const AppointmentRequestButton = ({
  isLoggedIn, isLoading, isError, onClick, appointmentUrl, testId, ecpService, isRequestButtonDisabled, appointmentType,
}: AppointmentRequestButtonProps): JSX.Element | null => {
  const intl = useIntl();
  const classes = useStyles();
  const serviceLabel = intl.formatMessage({ id: getServiceLabelId(appointmentType) });

  if (isLoggedIn && isLoading) {
    return <Preloader />;
  }

  if (isLoggedIn && isError) {
    return null;
  }

  return (
    <>
      {!isLoggedIn && <RequestButton onClick={onClick} appointmentUrl={appointmentUrl} ecpService={ecpService} />}
      {isLoggedIn && (
        <RequestButton
          disabled={isRequestButtonDisabled}
          onClick={onClick}
          appointmentUrl={appointmentUrl}
          ecpService={ecpService}
          testId={testId}
        />
      )}
      {isRequestButtonDisabled && (
        <div
          data-testid="active-appointment-message"
          className={classes.messageContainer}
        >
          {intl.formatMessage(
            { id: 'appointment.requestButton.message' },
            {
              p: (chunk: ReactNode) => (
                <p
                  className={classes.messagePartial}
                  data-testid="appointment-message-partial"
                >
                  {chunk}
                </p>
              ),
              link: (chunk: ReactNode) => (
                <Button
                  to={InternalLinks.appointment}
                  style="text"
                  rootClasses={classes.messageLink}
                  data-testid="appointment-message-link"
                >
                  {chunk}
                </Button>
              ),
              service: serviceLabel,
            },
          )}
        </div>
      )}
    </>
  );
};
